import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../constant";
import { toast } from "react-toastify";
import "../styles/Variable.css";
import "../styles/ManageMember.css";
import SideBar from "../components/SideBar";

const ManageSeniorAgentGroup = () => {
  const [seniorAgents, setSeniorAgents] = useState([]);
  const [selectedParentId, setSelectedParentId] = useState("");
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [parentSearch, setParentSearch] = useState("");
  const [memberSearch, setMemberSearch] = useState("");
  const [viewMiniAgentsModal, setViewMiniAgentsModal] = useState(false);
  const [selectedGroupMembers, setSelectedGroupMembers] = useState([]);
  const [editingGroup, setEditingGroup] = useState(null);

  useEffect(() => {
    fetchAgents();
    fetchGroups();
  }, []);

  const fetchAgents = async () => {
    try {
      const response = await axios.get(`${API_URL}/super-admin/senior-agent-groups/agents`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.data.success) {
        setSeniorAgents(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch agents", error);
      toast.error("Failed to load senior agents.");
    }
  };

  const fetchGroups = async () => {
    try {
      const response = await axios.get(`${API_URL}/super-admin/senior-agent-groups`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.data.success) {
        setGroups(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch groups", error);
    }
  };

  const handleCheckboxChange = (userId) => {
    if (selectedAgents.includes(userId)) {
      setSelectedAgents(selectedAgents.filter(id => id !== userId));
    } else {
      if (selectedAgents.length >= 5) {
        toast.warning("You can only select up to 5 agents.");
        return;
      }
      setSelectedAgents([...selectedAgents, userId]);
    }
  };

  const handleCreateGroup = async () => {
    if (!selectedParentId) {
      toast.error("Please select a parent Senior Agent ID (Left side).");
      return;
    }
    if (selectedAgents.length === 0) {
      toast.error("Please select at least one agent to group.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/super-admin/senior-agent-groups`, {
        parent_agent_id: selectedParentId,
        member_agent_ids: selectedAgents
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.success) {
        toast.success("Group created successfully!");
        setSelectedParentId("");
        setSelectedAgents([]);
        fetchGroups();
      }
    } catch (error) {
      console.error("Failed to create group", error);
      toast.error(error.response?.data?.message || "Failed to create group.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateGroup = async () => {
    if (selectedAgents.length === 0) {
      toast.error("Please select at least one agent to group.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.put(`${API_URL}/super-admin/senior-agent-groups/${editingGroup.id}`, {
        parent_agent_id: selectedParentId,
        member_agent_ids: selectedAgents
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.success) {
        toast.success("Group updated successfully!");
        setEditingGroup(null);
        setSelectedParentId("");
        setSelectedAgents([]);
        fetchGroups();
      }
    } catch (error) {
      console.error("Failed to update group", error);
      toast.error(error.response?.data?.message || "Failed to update group.");
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (group) => {
    setEditingGroup(group);
    setSelectedParentId(String(group.parent_user_id));
    setSelectedAgents(group.members ? group.members.map(m => m.user_id) : []);
  };

  const handleCancelEdit = () => {
    setEditingGroup(null);
    setSelectedParentId("");
    setSelectedAgents([]);
  };

  const alreadyGroupedUserIds = groups.reduce((acc, group) => {
    // If editing this group, do not add its parent or members to alreadyGrouped so they are selectable
    if (editingGroup && editingGroup.id === group.id) return acc;

    // Add both parent and members to alreadyGrouped, so they can't be added to any other group
    if (group.parent_user_id) acc.push(group.parent_user_id);
    if (group.members) {
      group.members.forEach(m => acc.push(m.user_id));
    }
    return acc;
  }, []);

  return (
    <div className="manage-member-layout" style={{ display: 'flex', minHeight: '100vh' }}>
      <SideBar />
      <div className="main-content" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '20px', borderBottom: '1px solid #ddd' }}>
            <h2 style={{ margin: 0 }}>Manage Senior Agent Groups</h2>
        </div>
        
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', gap: '20px', marginBottom: '40px', height: '500px' }}>
            {/* Left Column: Enter/Select Parent ID */}
            <div style={{ flex: 1, backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', display: 'flex', flexDirection: 'column' }}>
              <h3 style={{ marginBottom: '15px' }}>Enter Senior Agent ID (Lead)</h3>
              <input
                type="text"
                placeholder="Search by ID (e.g. S101) or Name..."
                value={parentSearch}
                onChange={(e) => setParentSearch(e.target.value)}
                style={{ width: '95%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '10px' }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flex: 1, overflowY: 'auto', paddingRight: '5px' }}>
                {seniorAgents.filter(agent => 
                  !alreadyGroupedUserIds.includes(agent.user_id) &&
                  !selectedAgents.includes(agent.user_id) &&
                  (`S${agent.agent_id+99}`.toLowerCase().includes(parentSearch.toLowerCase()) || 
                   agent.name.toLowerCase().includes(parentSearch.toLowerCase()))
                ).map(agent => (
                  <div key={agent.user_id} style={{ display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', padding: '10px', borderRadius: '4px', backgroundColor: 'white' }}>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontWeight: 'bold' }}>
                      <input
                        type="radio"
                        name="parentAgent"
                        checked={selectedParentId === String(agent.user_id)}
                        onChange={() => setSelectedParentId(String(agent.user_id))}
                        style={{ marginRight: '10px' }}
                      />
                      S{agent.agent_id+99} - {agent.name}
                    </label>
                  </div>
                ))}
                {seniorAgents.filter(agent => 
                  !alreadyGroupedUserIds.includes(agent.user_id) &&
                  !selectedAgents.includes(agent.user_id) &&
                  (`S${agent.agent_id+99}`.toLowerCase().includes(parentSearch.toLowerCase()) || 
                   agent.name.toLowerCase().includes(parentSearch.toLowerCase()))
                ).length === 0 && <p>No Senior Agents found matching search.</p>}
              </div>

            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
              {editingGroup ? (
                <>
                  <button onClick={handleUpdateGroup} disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                    {loading ? 'Updating...' : 'Update Group'}
                  </button>
                  <button onClick={handleCancelEdit} disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                    Cancel
                  </button>
                </>
              ) : (
                selectedParentId && (
                  <button onClick={handleCreateGroup} disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#2D4CA8', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                    {loading ? 'Creating...' : 'Create Group'}
                  </button>
                )
              )}
            </div>
          </div>

            {/* Right Column: List of all Senior Agents */}
            <div style={{ flex: 2, backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', display: 'flex', flexDirection: 'column' }}>
              <h3 style={{ marginBottom: '15px' }}>Select Senior Agents for Group</h3>
              <input
                type="text"
                placeholder="Search by ID (e.g. S101) or Name..."
                value={memberSearch}
                onChange={(e) => setMemberSearch(e.target.value)}
                style={{ width: '95%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flex: 1, overflowY: 'auto', paddingRight: '5px' }}>
                {seniorAgents.filter(agent => 
                  !alreadyGroupedUserIds.includes(agent.user_id) &&
                  String(agent.user_id) !== selectedParentId &&
                  (`S${agent.agent_id+99}`.toLowerCase().includes(memberSearch.toLowerCase()) || 
                   agent.name.toLowerCase().includes(memberSearch.toLowerCase()))
                ).map(agent => (
                  <div key={agent.user_id} style={{ display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', padding: '10px', borderRadius: '4px', backgroundColor: 'white' }}>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontWeight: 'bold' }}>
                      <input
                        type="checkbox"
                        checked={selectedAgents.includes(agent.user_id)}
                        onChange={() => handleCheckboxChange(agent.user_id)}
                        disabled={!selectedAgents.includes(agent.user_id) && selectedAgents.length >= 5}
                        style={{ marginRight: '10px' }}
                      />
                      S{agent.agent_id + 99} - {agent.name}
                    </label>
                    {/* Display MiniAgents */}
                    {/* {agent.mini_agents && agent.mini_agents.length > 0 && (
                      <div style={{ marginLeft: '30px', marginTop: '10px', fontSize: '0.9em', color: '#555' }}>
                        <p style={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>Introduced Mini Agents:</p>
                        <ul style={{ margin: 0, paddingLeft: '20px' }}>
                          {agent.mini_agents.map(mini => (
                            <li key={mini.user_id}>{mini.agent_code} - {mini.name}</li>
                          ))}
                        </ul>
                      </div>
                    )} */}
                  </div>
                ))}
                {seniorAgents.filter(agent => 
                  !alreadyGroupedUserIds.includes(agent.user_id) &&
                  String(agent.user_id) !== selectedParentId &&
                  (`S${agent.agent_id+99}`.toLowerCase().includes(memberSearch.toLowerCase()) || 
                   agent.name.toLowerCase().includes(memberSearch.toLowerCase()))
                ).length === 0 && <p>No Senior Agents found matching search.</p>}
              </div>
            </div>
          </div>

          {/* List of created groups */}
          <div>
            <h3>Existing Senior Agent Groups</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
              <thead>
                <tr style={{ backgroundColor: '#2D4CA8', color: 'white' }}>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Group Name</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Lead Agent</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Group Members</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {groups.map(group => (
                  <tr key={group.id}>
                    <td style={{ padding: '10px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                      {group.group_name} {group.members ? `(S${group.parent_agent_id + 99}${group.members.length > 0 ? ', ' + group.members.map(m => `S${m.agent_id + 99}`).join(', ') : ''})` : `(S${group.parent_agent_id + 99})`}
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>S{group.parent_agent_id + 99} - {group.parent_agent_name}</td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                      <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        {group.members.map(member => (
                          <li key={member.user_id}>S{member.agent_id + 99} - {member.name}</li>
                        ))}
                      </ul>
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <button 
                          onClick={() => {
                            setSelectedGroupMembers(group.members || []);
                            setViewMiniAgentsModal(true);
                          }}
                          style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '0.9em'
                          }}
                        >
                          View Hierarchy ({group.all_mini_agents ? group.all_mini_agents.length : 0} Mini Agents)
                        </button>
                        <button 
                          onClick={() => handleEditClick(group)}
                          style={{
                            backgroundColor: '#ff9800',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '0.9em'
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {groups.length === 0 && (
                  <tr>
                    <td colSpan="4" style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>No groups created yet.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal for viewing mini agents */}
      {viewMiniAgentsModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', 
          alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white', padding: '20px', borderRadius: '8px', 
            width: '700px', maxWidth: '90%', maxHeight: '80vh', 
            display: 'flex', flexDirection: 'column'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #ddd', paddingBottom: '10px', marginBottom: '15px' }}>
              <div>
                <h3 style={{ margin: 0 }}>Group's Hierarchy</h3>
                <div style={{ display: 'flex', gap: '15px', marginTop: '8px', fontSize: '0.9em', color: '#555', fontWeight: 'bold' }}>
                  <span style={{ backgroundColor: '#e3f2fd', padding: '4px 8px', borderRadius: '4px', color: '#1565c0' }}>Senior Agents: {selectedGroupMembers.length}</span>
                  <span style={{ backgroundColor: '#e8f5e9', padding: '4px 8px', borderRadius: '4px', color: '#2e7d32' }}>Mini Agents: {selectedGroupMembers.reduce((sum, m) => sum + (m.mini_agents ? m.mini_agents.length : 0), 0)}</span>
                  <span style={{ backgroundColor: '#fff3e0', padding: '4px 8px', borderRadius: '4px', color: '#e65100' }}>Customers: {selectedGroupMembers.reduce((sum, m) => sum + (m.mini_agents ? m.mini_agents.reduce((mSum, mini) => mSum + (mini.customers ? mini.customers.length : 0), 0) : 0), 0)}</span>
                </div>
              </div>
              <button onClick={() => setViewMiniAgentsModal(false)} style={{ border: 'none', background: 'none', fontSize: '1.5em', cursor: 'pointer' }}>&times;</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto' }}>
              {selectedGroupMembers.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  {selectedGroupMembers.map((member, mIndex) => (
                    <div key={mIndex} style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '6px' }}>
                      <h4 style={{ margin: '0 0 10px 0', color: '#2D4CA8' }}>Senior Agent: S{member.agent_id + 99} - {member.name}</h4>
                      
                      {member.mini_agents && member.mini_agents.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '20px' }}>
                          {member.mini_agents.map((mini, miIndex) => (
                            <div key={miIndex} style={{ borderLeft: '2px solid #eee', paddingLeft: '15px' }}>
                              <h5 style={{ margin: '0 0 10px 0', color: '#4CAF50' }}>Mini Agent: M{mini.agent_id + 99} - {mini.name}</h5>
                              
                              {mini.customers && mini.customers.length > 0 ? (
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
                                  <thead>
                                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                                      <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>Customer Name</th>
                                      <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'center', width: '120px' }}>Card Holder?</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {mini.customers.map((cust, cIndex) => (
                                      <tr key={cIndex}>
                                        <td style={{ padding: '6px', border: '1px solid #ddd' }}>{cust.name}</td>
                                        <td style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'center' }}>
                                          {cust.is_card_holder ? (
                                            <span style={{ color: 'white', backgroundColor: '#4CAF50', padding: '2px 8px', borderRadius: '10px', fontSize: '0.85em' }}>Yes</span>
                                          ) : (
                                            <span style={{ color: 'white', backgroundColor: '#f44336', padding: '2px 8px', borderRadius: '10px', fontSize: '0.85em' }}>No</span>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <p style={{ fontSize: '0.9em', color: '#777', margin: 0 }}>0 customers.</p>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p style={{ fontSize: '0.9em', color: '#777', margin: 0, paddingLeft: '20px' }}>0 mini agents.</p>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p>No hierarchy found for this group.</p>
              )}
            </div>
            <div style={{ marginTop: '15px', textAlign: 'right' }}>
              <button 
                onClick={() => setViewMiniAgentsModal(false)}
                style={{ backgroundColor: '#ccc', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageSeniorAgentGroup;
